export default {
    common: {
        fields: {
            birth_date: {
                placeholder: {
                    month: 'MM',
                    day: 'DD',
                    year: 'YYYY',
                },
            },
        },
    },

    auth: {
        register: {
            fields: {
                practice_type: {
                    label: 'Please choose practice type',
                    options: {
                        physician: { label: 'Provider practice', toolTip: 'NPI needed' },
                        ancillary: { label: 'Ancillary services', toolTip: 'Ancillary services; NPI needed' },
                        other: { label: 'Other', toolTip: 'Not a medical provider; No NPI' },
                    },
                },
                practice_name: {
                    label: 'Practice name',
                    placeholder: 'My practice name',
                },
                ancillary_name: {
                    label: 'Company name',
                    placeholder: 'My company name',
                },
                first_name: {
                    label: 'First name',
                    placeholder: 'John',
                },
                last_name: {
                    label: 'Last name',
                    placeholder: 'Smith',
                },
                middle_name: {
                    shortLabel: 'MI',
                    label: 'Middle Initial',
                    placeholder: 'J',
                },
                title: {
                    label: 'Title',
                    placeholder: 'Select',
                },
                email: {
                    label: 'Email',
                    placeholder: 'john.smith@myemail.com',
                    hint: 'Please enter your own personal email address here and not the practice email (which will be requested later).<br>You will use your personal email to log into MedMatch.<br><br>Third party medical practices will only be able to view your practice email address.',
                    repeat_label: 'Repeat your email',
                    repeat_hint: 'Please, repeat your email address',
                },
                phone: {
                    label: 'Phone',
                    mobile_sms_hint: 'You will be able to receive SMS notification after profile registration',
                    mobile_sms_hint_secondary: 'To receive SMS, enter mobile number. Fees may apply.',
                },
                password: {
                    label: 'Password',
                    placeholder: '10 characters minimum',
                    show_password: 'Show password',
                    hide_password: 'Hide password',
                },
                physicianGroup: {
                    label: 'Provider Group',
                    placeholder: 'Select one',
                },
                role: {
                    label: 'Your role in organization',
                    placeholder: 'Select one',
                    error: {
                        user_role_join_invitation_conflict:
                            'There is an outstanding invitation for the provider with the following email: {email}',
                    },
                },
                specialty: {
                    label: 'Specialty',
                    placeholder: 'Select one',
                },
                agree: {
                    label: `I agree to MedMatch’s <a href="${env(
                        'VUE_APP_WP_URL',
                    )}/privacy-policy" target="_new">Privacy Policy</a> and <a href="${env(
                        'VUE_APP_WP_URL',
                    )}/terms-of-service" target="_new">Terms of Service</a>.`,
                },
            },
            errors: {
                email: {
                    duplicate: {
                        message: 'Email already registered.',
                        link: 'Login to your account',
                    },
                    repeat: {
                        message: 'Provided email addresses do not match',
                    },
                },
                role: 'Role in organization is required',
                specialty: 'Specialty is required',
            },
            modals: {
                invite_admin: {
                    heading: 'Please send an invitation to your practice administrator or provider to register your practice.',
                    heading_mobile: 'Invite your practice administrator or provider to register your practice.',
                    assistant_nurse_wanring:
                        'If you want to create solo practice and work as a Solo Nurse Practitioner, please go back and choose different role',
                },
                email_field: {
                    label: 'Practice Administrator / Provider email',
                    placeholder: 'membername@email.com',
                    error: 'Email not valid',
                },
                buttons: {
                    send_invite: 'Send invite',
                },
            },
            microcopy: {
                signup: 'Sign up',
            },
        },
        practice: {
            fields: {
                insurance_plans: {
                    label: 'Insurance plans accepted',
                    placeholder: 'Select one',
                    placeholder_patient: "Patient's insurance plan",
                    start_typing: 'Start typing...',
                },
                invite_email: {
                    label: 'Practice administrator email',
                    placeholder: 'membername@email.com',
                },
                practice_email: {
                    label: 'Practice email address',
                    placeholder: 'email@yourpractice.com',
                    hint: 'Enter your practice email address here for making and receiving referrals as well as other inter-office communications.',
                },
                ancillary_email: {
                    label: 'Company email address',
                    placeholder: 'email@yourcompany.com',
                },
                location_name: {
                    label: {
                        primary: 'Primary practice location name',
                        secondary: 'Nickname of practice location',
                    },
                    placeholder: {
                        primary: 'Headquarters',
                        secondary: 'Location nickname',
                    },
                },
                location_address: {
                    label: 'Address',
                    placeholder: '5th Avenue 456',
                    main_location: 'Main Location: Address',
                },
                location_city: {
                    label: 'City',
                    placeholder: 'Palm Beach',
                },
                location_state: {
                    label: 'State',
                    placeholder: 'Select a State',
                },
                location_postcode: {
                    label: 'Zip',
                    placeholder: '12345',
                },
                facility_services: {
                    label: 'Services',
                    placeholder: 'Select',
                },
            },
            microcopy: {
                locations_repeater: {
                    heading: 'New practice location',
                    add: 'Add location',
                    hint: '(You can also do it later)',
                    remove: 'Remove',
                },
                locations_repeater_update: {
                    heading: 'Secondary Location',
                    hint: '',
                },
                invite_email: {
                    header: 'OR',
                    sub_header: 'Invite practice administrator',
                },
            },
            footer: {
                message: 'You are the Designated MedMatch Administrator for Your Practice.',
                hint: 'The MedMatch Administrator (MMA) has exclusive access to the practice account information, including managing subscription plans and billing information. The MMA can create provider member profiles and invite them to join the practice account. Only the MMA admits future members to the practice account. The MMA has access to referral analytic overview. The MMA can invite other members to manage the MedMatch Network account.',
            },
        },
        practice_ancillary: {
            fields: {
                services: 'Services',
                tests: 'Tests',
                locations: 'Locations',
            },
            button: {
                edit: 'Edit',
            },
        },
        profile: {
            fields: {
                npi_number: {
                    label: 'NPI number',
                    placeholder: '#NPI',
                    verify: 'Verify NPI',
                    upload_license: 'Upload License',
                    verified: 'NPI number verified successfully',
                    not_verified: 'Unable to verify NPI number. Please upload your medical license.',
                    verified_label: 'Verified',
                    processing_label: 'Processing',
                    npi_verified: 'NPI VERIFIED',
                    verification_success: 'NPI verification successful!',
                    verification_failed: 'NPI verification failed, please try again.',
                    details_not_match: 'NPI details did not match',
                    verify_or_upload_required: 'Please verify your NPI or upload a license before saving.',
                },
                license_file: {
                    label: 'Medical License',
                    upload_license: 'Upload License',
                    update_license: 'Upload New License',
                    upload_license_message: 'Upload license to receive MedMatch verification badge',
                    update_license_message: 'Upload new license to update your verified license',
                    license_verified: 'LICENSE VERIFIED',
                    license_rejected: 'LICENSE REJECTED',
                    license_processing: 'LICENSE PROCESSING',
                    upload_success: 'License uploaded successfully',
                    upload_failed: 'License upload failed. Please try again.',
                },
                license_number: {
                    label: 'License number',
                    placeholder: '#license',
                },
                license_issued_on: {
                    label: 'Year of license',
                    placeholder: 'Select year',
                },
                license_issued_by: {
                    label: 'Issued by',
                    placeholder: 'Select a State',
                },
            },
            microcopy: {
                licenses_repeater: {
                    heading: 'License #{index}',
                    add: 'Add license',
                    hint: '(You can also do it later)',
                    remove: 'Remove',
                },
            },
        },
        referrals: {
            fields: {
                speciality: {
                    label: 'Area of Practice',
                    placeholder: 'Select speciality',
                },
                subspeciality: {
                    label: 'Sub-speciality',
                    placeholder: 'Select sub-speciality',
                },
                practicing_since: {
                    label: 'Practicing since',
                    placeholder: 'Select year',
                },
                disciplinary_actions: {
                    label: 'Prior Disciplinary Actions',
                    hint: 'TODO: Fill this up.',
                },
                malpractice_claims_lost: {
                    label: 'Prior Malpractice Claims Lost / Unfavorable Decisions',
                    hint: 'Only lost claims. Does not include cases settled or dismissed.',
                },
                board_certified: {
                    label: 'Board certified',
                },
            },
            microcopy: {
                specialities_repeater: {
                    heading: 'Specialty #{index}',
                    add: 'Add speciality',
                    hint: '(You can also do it later)',
                    remove: 'Remove',
                },
            },
        },
        schedule: {
            fields: {
                location: {
                    label: 'Choose office location',
                    placeholder: 'Select location',
                },
                appointment_length: {
                    label: 'Typical appointment length',
                    placeholder: 'Select length',
                    hint: 'Please select your typical appointment time duration for new referrals.',
                    minutes: '1 minute | {n} minutes',
                },
                days: {
                    label: 'Add available slots to your schedule',
                    schedule_set_label: 'Your actual schedule applies to {days}',
                },
                frequency: {
                    label: 'Repeat schedule:',
                    options: {
                        weekly: 'Weekly',
                        biweekly: 'Bi-Weekly',
                    },
                },
                start_date: {
                    label: 'Start date:',
                },
            },
            microcopy: {
                all_locations: 'All practice locations',
                repeat_every: 'Repeats every',
                repeat_every_second: 'Repeats every second',
                applies_to_every: 'Applies to every',
                starting_from: 'Starting from',
                discard: 'Discard',
                apply: 'Apply',
                done: 'Done',
                cancel: 'Cancel',
                apply_to_others: 'Want to apply to other week days?',
                add_location_schedule: 'Add location schedule',
                save: 'Save',
                back_to_calendar: 'Back to schedule',
                apply_change: 'Apply change',
                set_another_location: 'SET FOR ANOTHER LOCATION',
                edit_timeline: 'EDIT AVAILABILITY',
                review: 'REVIEW',
            },
            modals: {
                appointment_length: {
                    heading_1: "You're about to change your standard appointment length.",
                    heading_2: 'This will apply to all future referrals.',
                    heading_3: "Existing bookings' appointment length will remain unchanged.",
                    content_1: 'You may need to adjust your hours of availability',
                    content_2: 'to cater for the new appintment length!',
                    footer: 'Are you sure you want to modify appointment length to {appointmentLength} minutes for the {locationName} location schedule?',
                },
                apply_changes: {
                    heading: 'Want to save the following changes to your "{locationName} location" availability?',
                },
                reschedule: {
                    heading_1:
                        '1 previously booked appointment is now out of your actual availability. | {n} previously booked appointments are now out of your actual availability.',
                    heading_2: 'You can reschedule it. | You can reschedule them one by one.',
                    content: '1 appointment to be rescheduled | {n} appointments to be rescheduled',
                    buttons: {
                        reschedule_them: 'Reschedule it | Reschedule them',
                    },
                },
            },
        },
        login: {
            fields: {
                email: {
                    label: 'Email',
                    placeholder: 'john.smith@myemail.com',
                },
                password: {
                    label: 'Password',
                    placeholder: 'Enter password',
                },
            },
            microcopy: {
                login: 'Log in',
                forgot_password: 'Forgot password?',
                not_found_error: 'Incorrect email or password.',
                not_verified: 'User is not verifed',
                resend: 'Resend verification link',
                email_sent: 'Verification email sent',
            },
        },
        forgot_password: {
            fields: {
                email: {
                    label: 'Email',
                    placeholder: 'john.smith@myemail.com',
                },
            },
            microcopy: {
                reset_password: 'Reset password',
            },
        },
        reset_password: {
            fields: {
                password: {
                    label: 'Password',
                    placeholder: '10 characters minimum',
                },
                confirm_password: {
                    label: 'Confirm password',
                },
            },
            errors: {
                password: {
                    confirm: 'Password and confirmation do not match.',
                    expired: 'Request expired! Please try again.',
                    length: 'Password must be at least 10 characters long',
                    wrong: 'Wrong password! Please try again.',
                    something_wrong: 'Something went wrong. Please try with another password.',
                },
            },
            microcopy: {
                reset_password: 'Set password',
            },
        },
    },

    referrals: {
        search: {
            fields: {
                practice_type: {
                    label: 'Practice type',
                },
                patient_insurance: {
                    label: 'Patient insurance',
                    placeholder: 'Start typing...',
                },
                facility_service: {
                    label: 'Service type',
                    placeholder: 'Select service type',
                },
                tests: {
                    label: 'Tests',
                    placeholder: 'Start typing...',
                },
                speciality: {
                    label: 'Speciality',
                    placeholder: 'Select a speciality',
                },
                subspeciality: {
                    label: 'Sub-speciality',
                    placeholder: 'Select a sub-speciality',
                },
                search_by: {
                    label: 'Search by',
                    options: {
                        zipcode: 'ZIP code',
                        patient_address: 'Patient address',
                    },
                },
                search_by_time_window: {
                    label: 'When',
                },
                patient_address: {
                    label: 'Address',
                    placeholder: '5th Avenue 456',
                },
                patient_city: {
                    label: 'City',
                    placeholder: 'Palm Beach',
                },
                patient_state: {
                    label: 'State',
                    placeholder: 'Select a State',
                },
                patient_zipcode: {
                    label: 'ZIP code',
                    placeholder: '12345',
                },
                patient_floor_number: {
                    label: 'Floor Number',
                    placeholder: '1',
                },
                patient_apartment_number: {
                    label: 'Apartment Number',
                    placeholder: '1',
                },
                patient_building_number: {
                    label: 'Building Number',
                    placeholder: '1',
                },
            },
            buttons: {
                send: 'Find a provider',
            },
        },
        errors: {
            test_ids_error: 'Please select at least one test for each service type',
        },
        make: {
            fields: {
                insurance_authorization_required: {
                    label: 'Insurance authorization required?',
                },
                patient_primary_care_physician: {
                    label: 'Patient primary care provider',
                    options: {
                        other: 'Other',
                    },
                },
                diagnosis: {
                    label: 'Diagnosis',
                    placeholder: 'Diagnosis',
                },
                icd10_code: {
                    label: 'ICD 10 Code (optional)',
                    placeholder: 'ICD 10',
                },
                patient_last_name: {
                    label: 'Patient Last Name',
                    placeholder: 'Smith',
                },
                patient_first_name: {
                    label: 'Patient First Name',
                    placeholder: 'John',
                    born_on: '{name}, born on {date}',
                },
                patient_birth_date: {
                    label: 'Patient Date of Birth',
                },
                patient_insurance: {
                    label: 'Patient Insurance',
                    not_selected: 'Insurance Plan not selected',
                },
                patient_mobile_phone: {
                    label: 'Patient Phone number',
                    info: 'Preferably mobile. Patient will get SMS messages if agrees to terms and conditions.',
                },
                patient_ssn: {
                    label: 'Last Four SSN',
                    placeholder: '****',
                },
                note: {
                    label: 'Add a note (specify service needed, attach patient records,...)',
                    placeholder: 'Type you note or specify diagnostic service needed. E.g. "MRI for right shoulder"',
                    overlay: 'Add files',
                },
                physician_full_name: {
                    label: 'Full Name',
                    placeholder: 'John Smith',
                },
                physician_email_address: {
                    label: 'Email Address (optional)',
                    placeholder: 'email@address.com',
                    hint: 'Without an email address you will have to call primary care provider to receive authorization.',
                },
                physician_phone_number: {
                    label: 'Phone Number',
                },
                physician_fax_number: {
                    label: 'Fax Number (optional)',
                    placeholder: 'fax #',
                },
                insurance_group: {
                    label: 'Insurance Group # (optional)',
                    placeholder: 'Enter #',
                },
                insurance_id: {
                    label: 'Insurance ID # (optional)',
                    placeholder: '#ID',
                },
                email: {
                    label: 'Email (optional)',
                    placeholder: 'john.smith@myemail.com',
                },
                middle_name: {
                    label: 'MI (Optional)',
                    placeholder: 'J',
                },
            },
            groups: {
                primary_care_physician: 'Patient primary care provider details',
            },
            buttons: {
                send: 'Request appointment',
                reset: 'Start over',
            },
        },
    },

    referrals_pool: {
        make: {
            buttons: {
                send: 'Send referral',
                reset: 'Start over',
            },
        },
    },

    availability: {
        schedule: {
            fields: {
                location: {
                    label: 'Choose office location',
                    placeholder: 'Select location',
                },
                appointment_length: {
                    label: 'Typical appointment length',
                    placeholder: 'Select length',
                    hint: 'Please select your typical appointment time duration for new referrals.',
                    minutes: '1 minute | {n} minutes',
                },
                days: {
                    label: 'Add available slots to your schedule',
                },
                frequency: {
                    label: 'Repeat schedule:',
                    options: {
                        weekly: 'Weekly',
                        biweekly: 'Bi-Weekly',
                    },
                },
                start_date: {
                    label: 'Start date:',
                },
            },
            microcopy: {
                all_locations: 'All practice locations',
                repeat_every: 'Repeats every',
                repeat_every_second: 'Repeats every second',
                starting_from: 'Starting from',
                discard: 'Discard',
                apply: 'Apply',
                done: 'Done',
                apply_to_others: 'Want to apply to other week days?',
                add_location_schedule: 'Add location schedule',
            },
        },
        buttons: {
            save: 'Save',
        },
    },

    terms_of_use: {
        support: {
            fields: {
                email: {
                    label: 'Email',
                    placeholder: 'john.smith@myemail.com',
                },
                name: {
                    label: 'Full Name',
                    placeholder: 'John Smith',
                },
                message: {
                    label: 'Your message',
                    placeholder: 'Type your message here..',
                },
            },
            buttons: {
                send: 'Send',
            },
        },
    },
    professional_info: {
        licenses_repeater: {
            input: 'License #{number}',
            heading: 'Your licences',
            add: 'Add license',
            remove: 'Remove',
        },
        medical_schools_repeater: {
            input: '',
            heading: 'Medical school (optional)',
            add: 'Add another school',
            remove: 'Remove',
        },
        residencies_repeater: {
            input: '',
            heading: 'Residency (optional)',
            add: 'Add another residency',
            remove: 'Remove',
        },
        fellowships_repeater: {
            input: '',
            heading: 'Fellowship (optional)',
            add: 'Add another  fellowship',
            remove: 'Remove',
        },
        affiliated_hospitals_repeater: {
            input: '',
            heading: 'Affiliated hospitals',
            add: 'Add another hospital',
            remove: 'Remove',
        },
        city: {
            label: 'City',
            placeholder: 'New York',
        },
        state: {
            label: 'State',
            placeholder: 'Select a State',
        },
        medical_schools: {
            label: 'School name',
            placeholder: 'New York University',
            delete: 'Delete school',
        },
        residencies: {
            label: 'University',
            placeholder: 'Brooklyn Hospital Center Program',
            delete: 'Delete residency',
        },
        fellowships: {
            label: 'University',
            placeholder: 'Brooklyn Hospital Center',
            delete: 'Delete fellowship',
        },
        affiliated_hospitals: {
            label: 'Hospital name',
            placeholder: 'Brooklyn Hospital Center',
            delete: 'Delete hospital',
        },
        short_biography: {
            label: 'Short biography/presentation',
            placeholder: 'In my practice we put patients first',
        },
        sub_specialities: {
            label: 'Sub-Specialities',
        },
        license: {
            delete: 'Delete license',
        },
    },
    profile: {
        account_information: {
            fields: {
                first_name: {
                    label: 'First name',
                    placeholder: 'John',
                },
                last_name: {
                    label: 'Last name',
                    placeholder: 'Smith',
                },
                title: {
                    label: 'Title',
                    placeholder: 'Select',
                },
                gender: {
                    label: 'Gender (Optional)',
                    placeholder: 'Choose',
                },
                languages: {
                    label: 'Languages spoken (Optional)',
                    placeholder: 'Select',
                },
                phone: {
                    label: 'Phone number',
                    placeholder: '1234567890',
                },
                email: {
                    label: 'Email address',
                },
                password: {
                    label: 'Password',
                },
                mobile_phone: {
                    label: 'Mobile Phone number',
                    placeholder: '1234567890',
                },
                agree_to_sms: {
                    label: `I agree to receive SMS from MedMatch Network.`,
                },
            },
            buttons: {
                modify_password: 'Modify',
                change_email: 'Change email address',
                upload_profile_picture: 'Upload profile picture',
                upload_practice_profile_picture: 'Upload practice logo',
            },
            messages: {
                password: 'Password successfully changed',
            },
        },
    },

    practice: {
        account_information: {
            fields: {
                practice_name: {
                    label: 'Practice name',
                    placeholder: 'Practice name',
                },
                phone: {
                    label: 'Practice phone number',
                    placeholder: '1234567890',
                },
                email: {
                    label: 'Practice Email address',
                },
                password: {
                    label: 'Account Password',
                },
                fax_number: {
                    label: 'Fax number',
                    placeholder: '1234567890',
                },
            },
            insurance_plans: {
                label: 'Select insurance plans accepted',
            },
            primary_location: {
                label: 'Primary practice location',
            },
            buttons: {
                modify_password: 'Change',
                change_email: 'Change email address',
                select_insurances: 'Select',
                modify_insurances: 'Modify',
            },
        },
    },
    patient: {
        patient_information: {
            fields: {
                insurance_plans: {
                    label: 'Insurance plans accepted',
                    placeholder: 'Select one',
                    placeholder_patient: 'Insurance Plan',
                    start_typing: 'Start typing...',
                    options: 'Active',
                },
                practice_name: {
                    label: 'Patient insurance',
                    placeholder: 'Self Pay',
                },
                Insurance: {
                    label: 'Insurance Group ',
                    placeholder: 'N/A',
                    options: 'Optional',
                },
                Insurance_id: {
                    label: 'Insurance ID ',
                    placeholder: 'N/A',
                },

                date: {
                    label: 'Date of Birth',
                    placeholder: '16 January  1987',
                },
                inform: {
                    label: 'Personal Information',
                    label_1: 'Insurance Information',
                    label_2: 'Guarantor Information',
                    label_3: 'Address Information',
                },

                SSN: {
                    label: 'Last Four SSN',
                    placeholder: '****',
                },
                email: {
                    label: 'Email Address',
                    placeholder: 'john.smith@myemail.com',
                },
                phone: {
                    label: 'Phone number',
                    placeholder: '1234567890',
                },
                location_address: {
                    label: 'Address',
                    placeholder: '5th Avenue 456',
                },
                guarantor: {
                    label: 'Guarantor',
                    placeholder: 'John Smith',
                },
                guarantor_Number: {
                    label: 'Guarantor Phone Number',
                    placeholder: '1234567890',
                },
                city: {
                    label: 'City',
                    placeholder: 'New York',
                },
                state: {
                    label: 'State',
                    placeholder: 'Select a State',
                },
                zip: {
                    label: 'Zip',
                    placeholder: '12345',
                },
                floor_number: {
                    label: 'Floor Number',
                    placeholder: '1',
                },
                apartment_number: {
                    label: 'Apartment Number',
                    placeholder: '1',
                },
                building_number: {
                    label: 'Building Number',
                    placeholder: '1',
                },
            },
            insurance_plans: {
                label: 'Select insurance plans accepted',
            },
            primary_location: {
                label: 'Primary practice location',
            },
            buttons: {
                modify_password: 'Change',
                change_email: 'Change email address',
                select_insurances: 'Select',
                modify_insurances: 'Modify',
            },
        },
    },
    addpatient: {
        heading: 'Fill Patient Information',
        fields: {
            demographics: {
                label: 'Demographics',
            },
            emergency: {
                label: 'Emergency Contact',
            },
            pharmacy: {
                label: 'Preferred Pharmacy',
            },
            insurance_plans: {
                label: 'Insurance plans accepted',
                placeholder: 'Select one',
                placeholder_patient: "Patient's insurance plan",
                start_typing: 'Start typing...',
            },
            insurance: {
                label: 'Insurance Group',
                placeholder: '1234',
            },
            insurance_id: {
                label: 'Insurance ID (optional)',
                placeholder: 'ZGN000123456',
            },
            name: {
                label: 'First Name',
                placeholder: 'John',
            },
            lastname: {
                label: 'Last Name',
                placeholder: 'Smith',
            },
            id: {
                label: '#ID',
                placeholder: '#1234',
            },
            patient_email: {
                label: 'Attach Documents: (ID, Insurance Card etc..)',
                placeholder: 'enter here',
            },
            date: {
                label: 'Date of Birth',
            },
            ssn: {
                label: 'Last Four SSN',
                placeholder: '****',
            },
            phone: {
                label: 'Phone Number',
                placeholder: '1234567890',
            },
            address: {
                label: 'Address',
                placeholder: '',
            },
            email: {
                label: 'Email Address (optional)',
                placeholder: 'john.doe@email.com',
            },
            guarantor: {
                label: 'Gaurantor',
                name: {
                    label: 'Guarantor First Name',
                    placeholder: 'John',
                },
                lastname: {
                    label: 'Guarantor Last Name',
                    placeholder: 'Smith',
                },
                phone: {
                    label: 'Guarantor Phone Number',
                    placeholder: '1234567890',
                },
                address: {
                    label: 'Address',
                    placeholder: '',
                },
            },
            city: {
                label: 'City',
                placeholder: 'New York',
            },
            state: {
                label: 'State',
                placeholder: 'Select a State',
            },
            zip: {
                label: 'Zip',
                placeholder: '12345',
            },
            floor_number: {
                label: 'Floor Number',
                placeholder: '1',
            },
            apartment_number: {
                label: 'Apartment Number',
                placeholder: '1',
            },
            building_number: {
                label: 'Building Number',
                placeholder: '1',
            },
            // email: {
            //     label: 'Patient Email',
            //     placeholder: 'john.smith@myemail.com',
            // },
        },
    },
    check_password: {
        wrong_password: 'Wrong password',
        fields: {
            password: {
                label: 'Enter Password',
                placeholder: '',
            },
        },
        buttons: {
            ok: 'ok',
            cancel: 'Cancel',
        },
    },
    patient_message: {
        fields: {
            password: {
                label: 'Message',
                placeholder: 'Enter Message',
            },
        },
    },
    change_password: {
        not_matching: 'Passwords do not match',
        fields: {
            old_password: {
                label: 'Old Password',
                placeholder: 'Enter old password',
            },
            new_password: {
                label: 'New Password',
                placeholder: '10 characters minimum',
            },
            repeat_password: {
                label: 'Repeat Password',
                placeholder: 'Repeat new password',
            },
        },
        buttons: {
            save: 'Save',
            cancel: 'Cancel',
        },
    },
    change_email: {
        not_matching: 'Emails do not match',
        fields: {
            email: {
                change_email: 'New email',
                confirm_email: 'Confirm email',
                placeholder: 'john.smith@myemail.com',
            },
        },
        buttons: {
            save: 'Save',
            cancel: 'Cancel',
        },
    },

    change_practice_email: {
        fields: {
            email: {
                change_email: 'New email',
                confirm_email: 'Confirm email',
                placeholder: 'john.smith@myemail.com',
            },
        },
        buttons: {
            save: 'Confirm',
            cancel: 'Cancel',
        },
    },
    practice_ancillary: {
        fields: {
            services: 'Services',
            tests: 'Tests',
            locations: 'Locations',
            insurance: 'Insurance',
        },
        info: {
            no_tests: 'Adding specific tests will increase your change to receive referrals',
        },
        button: {
            edit: 'Edit',
            add_tests: 'Add tests',
            start_now: 'Start now',
            modify: 'Modify',
            add_modify: 'Add / Modify',
            done: 'Done',
            select_more_tests: 'Select more tests',
        },
        labels: {
            add_tests: 'Add tests for services',
        },
    },

    email_form: {
        form_labels: {
            to: 'To: ',
            cc: 'Cc: ',
            subject: 'Subject: ',
            from: 'From: ',
            message: 'Your message:',
        },
        placeholder: {
            to: 'All recipients will be Bcc',
            message: 'Type your message here',
            search: 'Select member to message',
        },
        cursor_message: {
            attach_button: 'Attach in email app',
        },
        email: {
            hint: 'All other memebers will be Bcc',
        },
    },

    patient_profile: {
        fields: {
            profile: {
                label: 'Document Type',
                placeholder: 'Select document type',
                insurance_plans: {
                    placeholder: 'Select one',
                },
                fileName: {
                    label: 'File Name',
                    placeholder: 'e.g. Lab_Report.pdf, Xray_Image.jpg',
                },
                document: {
                    label: 'Document Date',
                    placeholder: 'dd-mm-yyyy',
                },
                provider: {
                    label: 'Provider/Source',
                    placeholder: 'e.g., Dr. Smith, ABC Hospital',
                },
                comment: {
                    label: 'Comments',
                    placeholder: 'Additional notes about this document',
                },
                additional: {
                    label: 'Additional Notes',
                    placeholder: 'Any specific instructions or additional information...',
                },
                full_name: {
                    label: 'Full Name',
                    placeholder: 'Enter full name',
                },
                first_name: {
                    label: 'First Name',
                    placeholder: 'Enter first name',
                },
                last_name: {
                    label: 'Last Name',
                    placeholder: 'Enter last name',
                },
                dob: {
                    label: 'Date of Birth',
                    placeholder: '16-01-1987',
                },
                gender: {
                    label: 'Gender',
                    placeholder: 'Male',
                },
                marital_status: {
                    label: 'Marital Status',
                    placeholder: 'Single',
                },
                language: {
                    label: 'Primary Language',
                    placeholder: 'English',
                },
                ssn: {
                    label: 'Last Four SSN',
                    placeholder: '***-**-4261',
                },
                email: {
                    label: 'Email Address',
                    placeholder: 'amos.david@email.com',
                },
                alternate_phone: {
                    label: 'Alternate Phone',
                    placeholder: '4075094262',
                },
                primary_phone: {
                    label: 'Primary Phone',
                    placeholder: '4075094261',
                },
                contact_info: {
                    label: 'Preferred Contact Method',
                    placeholder: 'Phone',
                },
                address: {
                    street: {
                        label: 'Street Address',
                        placeholder: '5th Avenue 456',
                    },
                    city: {
                        label: 'City',
                        placeholder: 'New York',
                    },
                    state: {
                        label: 'State',
                        placeholder: 'Select a State',
                    },
                    zip: {
                        label: 'ZIP Code',
                        placeholder: '12345',
                    },
                },
            },
            emergency: {
                first_name: {
                    lable: 'First Name',
                    placeholder: 'Enter First Name',
                },
                last_name: {
                    lable: 'Last Name',
                    placeholder: 'Enter Last Name',
                },
                phone: {
                    lable: 'Phone',
                    placeholder: '4075094261',
                },
                email: {
                    lable: 'Email',
                    placeholder: 'Enter Email',
                },
                relationship: {
                    lable: 'Relationship',
                    placeholder: 'sister',
                },
            },
            pharmacy: {
                name: {
                    lable: 'Name',
                    placeholder: 'CVS Pharmacy',
                },
                address: {
                    label: 'Address',
                    placeholder: '1250 Beach Blvd, Jacksonville, FL 32207',
                },
                phone: {
                    lable: 'Phone',
                    placeholder: '904-398-2200',
                },
                fax: {
                    lable: 'Fax',
                    placeholder: '904-398-2201',
                },
                email: {
                    label: 'Email',
                    placeholder: 'john.smith@myemail.com',
                },
            },
            hipaa: {
                label: 'Authorization Name *',
                insurance_plans: {
                    placeholder: 'e.g., General Medical Records Authorization',
                },
                document: {
                    label: 'Expiry Date *',
                    placeholder: 'dd-mm-yyyy',
                },
                provider: {
                    label: 'Authorized Providers',
                    placeholder: 'e.g., Mayo Clinic, General Hospital (comma separated)',
                },
                comment: {
                    label: 'Scope of Authorization',
                    placeholder: 'Select scope',
                },
                authorization: {
                    label: 'HIPAA Authorization Form *',
                    placeholder: 'Select a HIPAA authorization form',
                },
            },
            email: {
                label: 'Provider/Facility Name *',
                insurance_plans: {
                    placeholder: 'e.g., General Hospital',
                },
                document: {
                    label: 'Medical Records Email *',
                    placeholder: 'medicalrecords@hospital.com',
                },
                provider: {
                    label: 'Phone Number',
                    placeholder: '(555) 123-4567',
                },
                address: {
                    label: 'Address',
                    placeholder: '123 Main St, City, State 12345',
                },
            },
            date_range: {
                label: 'From',
                insurance_plans: {
                    placeholder: 'dd-mm-yyyy',
                },
                document: {
                    label: 'To',
                    placeholder: 'dd-mm-yyyy',
                },
                provider: {
                    label: 'Purpose of Request',
                    placeholder: 'Select purpose',
                },
                address: {
                    label: 'Address',
                    placeholder: '123 Main St, City, State 12345',
                },
                button: {
                    label: 'Submit Request',
                },
            },
            search: {
                placeholder: ' Search by hospital name, specialty, or location...',
            },
        },
    },

    view_document: {
        fields: {
            search: {
                placeholder: 'Search documents...',
            },
            type: {
                placeholder: 'All Types',
            },
            source: {
                placeholder: 'All Providers',
            },
        },
    },
}
